
import { Configuration, LogLevel } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
        // Using the Client ID provided by the user as the primary ID
        clientId: (process.env as any).VITE_AZURE_CLIENT_ID || "73f19b13-4587-46d9-8679-ab7185235de9",
        authority: `https://login.microsoftonline.com/${(process.env as any).VITE_AZURE_TENANT_ID || "nottingham.ac.uk"}`,
        // Ensures the redirect matches the current browser origin (e.g., https://www.pharmgrade.co.uk)
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage",
        // Fix: Removed storeAuthStateInCookie as it is not a recognized property in the current MSAL type definitions and defaults to false.
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const loginRequest = {
    scopes: ["User.Read"],
};
